/*********************************************************
 * Copyright (C) 2018 VMware, Inc. All rights reserved.
 *********************************************************/

/**
 * jscdk-feature-status.ts --
 *
 *      Model to store feature status,
 *      defaultly all to false.
 */
let FeatureStatusModel = function() {
   this.status = {
      "AzureConnectionRetry": false
   };
   this.set = function(status) {
      for (let key in status) {
         if (this.status.hasOwnProperty(key)) {
            this.status[key] = status[key];
         }
      }
   };
   this.getStatus = function(name) {
      if (!name || !(name in this.status)) {
         return false;
      }
      return this.status[name];
   };
};

let model = new FeatureStatusModel();

export default model;